import { IconConfig } from "../types";

export const calculator: IconConfig = {
  type: 'complex' as const,
  viewBox: "0 0 24 24",
  elements: [
    {
      type: 'rect',
      width: 16,
      height: 20,
      x: 4,
      y: 2,
      rx: 2,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    {
      type: 'line',
      x1: 8,
      x2: 16,
      y1: 6,
      y2: 6,
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    {
      type: 'line',
      x1: 16,
      x2: 16,
      y1: 14,
      y2: 18,
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    {
      type: 'path',
      d: "M16 10h.01",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    {
      type: 'path',
      d: "M12 10h.01",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    {
      type: 'path',
      d: "M8 10h.01",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    {
      type: 'path',
      d: "M12 14h.01",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    {
      type: 'path',
      d: "M8 14h.01",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    {
      type: 'path',
      d: "M12 18h.01",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    {
      type: 'path',
      d: "M8 18h.01",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ] as const
}
